import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import './Hero.css';

const Hero = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const t = translations[currentLanguage];
  
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  const handlePrimaryAction = () => {
    if (currentLanguage === 'cs' || currentLanguage === 'en') {
      changeLanguage('uk');
    } else {
      scrollToContact();
    }
  };
  
  const handleSecondaryAction = () => {
    if (currentLanguage === 'cs' || currentLanguage === 'en') {
      changeLanguage('uk');
    } else {
      document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="highlight">{t.hero.title}</span>
            </h1>
            <p className="hero-subtitle">
              {t.hero.subtitle}
            </p>
            <p className="hero-description">
              {t.hero.description}
            </p>
            {(currentLanguage === 'cs' || currentLanguage === 'en') && (
              <div className="language-notice">
                <p>{t.hero.notice}</p>
              </div>
            )}
                <div className="hero-buttons">
                  <button className="btn btn-primary" onClick={handlePrimaryAction}>
                    {t.hero.bookConsultation}
                  </button>
                  <button className="btn btn-secondary" onClick={handleSecondaryAction}>
                    {t.hero.learnMore}
                  </button>
                </div>
                <div className="hero-decoration">
                  <img src="/images/rose.png" alt="Rose decoration" className="hero-rose" />
                </div>
          </div>
          <div className="hero-image">
            <div className="hero-avatar">
              <img 
                src="/images/ludmila-photo-1.jpg" 
                alt={t.hero.title}
                className="hero-photo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
